import { useState } from 'react'
import { Card, CardHeader, CardTitle, CardDescription, CardContent, Button, Textarea, Label } from '@/components/ui'
import { Globe } from 'lucide-react'

export function SitemapGenerator() {
  const [urls, setUrls] = useState('')
  const [sitemap, setSitemap] = useState('')

  const handleGenerate = () => {
    const urlArray = urls.split('\n').filter(url => url.trim() !== '')
    const sitemapContent = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urlArray.map(url => `  <url>
    <loc>${url}</loc>
  </url>`).join('\n')}
</urlset>`
    setSitemap(sitemapContent)
  }

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-blue-500/20 to-cyan-500/20">
            <Globe className="h-6 w-6 text-blue-500" />
          </div>
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Sitemap Generator</h1>
            <p className="text-muted-foreground">Create sitemaps for your website</p>
          </div>
        </div>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <Card className="glass">
          <CardHeader>
            <CardTitle>Input</CardTitle>
            <CardDescription>Enter one URL per line</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label>URLs</Label>
              <Textarea
                value={urls}
                onChange={(e) => setUrls(e.target.value)}
                placeholder="https://example.com\nhttps://example.com/about"
                className="h-48"
              />
            </div>
            <Button onClick={handleGenerate}>Generate</Button>
          </CardContent>
        </Card>

        <Card className="glass">
          <CardHeader>
            <CardTitle>Output</CardTitle>
            <CardDescription>Generated sitemap</CardDescription>
          </CardHeader>
          <CardContent>
            <Textarea
              value={sitemap}
              readOnly
              className="h-48 font-mono"
            />
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
